// Mock content data for Amanda Abbott's site
// All editable — easily replaced later with real content

export const AMANDA_PHOTO =
  "https://customer-assets.emergentagent.com/wingman/de93a0f2-b577-4813-a04c-4e6e0b033d83/attachments/011bc8078db2483086c61f35716ab265_Image-03.jpg";

export const HERO = {
  eyebrow: "Brand · Design · Systems",
  name: "Amanda Abbott",
  tagline:
    "Product designer, systems thinker, and brand strategist bridging design and engineering.",
  intro:
    "13+ years across brand, design, and technology — from Xbox executive presentations at Microsoft to founding an internationally-stocked luxury label. Now consulting from the Sunshine Coast.",
};

export const ABOUT = {
  paragraphs: [
    "I'm Amanda — a product designer and systems thinker based on Australia's Sunshine Coast, with 13+ years across brand, design, and technology.",
    "My work sits at the intersection of design and engineering. I've designed executive presentations at Microsoft for Xbox and Microsoft Health leadership — supporting Phil Spencer, Panos Panay, Todd Holmdahl and others — and founded LUXLA, a luxury accessories label stocked internationally and worn by clients including Whitney Port, Emmy Rossum, and Abigail Breslin. In between I've designed collections for NastyGal, Wasteland, and Sofia Boutique, and consulted with C-level executives to translate strategy into visuals that move companies forward.",
    "Today I focus on brand development, product design, and consulting for founders and executives — and speak openly about building a professional life around AuDHD and Ehlers-Danlos syndrome.",
  ],
  stats: [
    { value: "13+", label: "Years across brand, design & product" },
    { value: "Ex-MSFT", label: "Xbox & Microsoft Health leadership" },
    { value: "LUXLA", label: "Founder · shipped internationally" },
  ],
};

export const EXPERTISE = [
  {
    id: "brand",
    title: "Brand Development",
    description:
      "Identity, voice, and positioning for founders and growing businesses. Previously designed collections and marketing for NastyGal, Wasteland, and Sofia Boutique.",
    bullets: ["Visual identity & guidelines", "Brand voice & messaging", "Go-to-market strategy"],
  },
  {
    id: "consulting",
    title: "C-Level Consulting",
    description:
      "Strategic advisory and executive-grade communications for senior leaders. Designed presentations for Microsoft Xbox leadership including Phil Spencer, Panos Panay, and Todd Holmdahl.",
    bullets: ["Executive presentation design", "Strategy & roadmap visuals", "Board & investor decks"],
  },
  {
    id: "product",
    title: "Product Design & Systems",
    description:
      "Systems thinking applied to physical and digital products. B.S. Industrial & Product Design (University of Oregon). Focus on AI, emerging tech, and human-centered systems.",
    bullets: ["UX research & flows", "Design systems", "AI-assisted prototyping"],
  },
  {
    id: "modeling",
    title: "Modeling & Editorial",
    description:
      "Editorial and commercial modeling with a focus on mature, inclusive, and authentic representation.",
    bullets: ["Editorial campaigns", "Lifestyle & commercial", "Brand ambassadorship"],
  },
];

export const PORTFOLIO = [
  {
    title: "The Quiet Rebrand",
    category: "Brand Development",
    blurb: "Identity refresh for a wellness studio repositioning to mature, sensory-led audiences.",
    image:
      "https://images.unsplash.com/photo-1505330622279-bf7d7fc918f4?auto=format&fit=crop&w=900&q=80",
  },
  {
    title: "Executive Voice Lab",
    category: "C-Level Consulting",
    blurb: "Communications coaching program for a SaaS leadership team preparing for Series B.",
    image:
      "https://images.unsplash.com/photo-1582653291997-079a1c04e5a1?crop=entropy&cs=srgb&fm=jpg&w=900&q=85&ixlib=rb-4.1.0",
  },
  {
    title: "Soft Tech",
    category: "Product Design",
    blurb: "End-to-end product design for a calm-tech health companion app for chronic illness.",
    image:
      "https://images.unsplash.com/photo-1551650975-87deedd944c3?auto=format&fit=crop&w=900&q=80",
  },
  {
    title: "Editorial: Coastal Light",
    category: "Modeling",
    blurb: "Editorial campaign celebrating mature beauty along the Sunshine Coast.",
    image:
      "https://customer-assets.emergentagent.com/job_portfolio-hub-2548/artifacts/v7od6dk8_KB1_7985.jpg",
  },
];

export const VINTAGE_IMAGE =
  "https://images.unsplash.com/photo-1778182544519-47e71398c6fb?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85&ixlib=rb-4.1.0";

export const VINTAGE = {
  title: "The Vintage Vault",
  subtitle: "Curated luxury, considered ownership.",
  body:
    "A rotating, hand-picked collection of vintage and pre-loved luxury — gold, leather, silk, story. Each piece is researched, authenticated, and styled for a second life with someone who'll love it.",
  highlights: ["Authenticated luxury", "One-of-one pieces", "Sustainable curation"],
};

export const ADVOCACY_IMAGE =
  "https://images.unsplash.com/photo-1728675437273-d83d4cfaf938?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85&ixlib=rb-4.1.0";

export const ADVOCACY = {
  title: "Visible work for invisible illness.",
  body:
    "I live with AuDHD and Ehlers-Danlos syndrome — conditions often invisible, frequently misunderstood, and rarely seen in professional spaces. I write, speak, and consult on how to make workplaces and communities genuinely accessible to neurodivergent and chronically ill people.",
  pillars: [
    { title: "Speaking", text: "Talks for teams, councils & community groups." },
    { title: "Writing", text: "Essays on neurodivergence, work, and design." },
    { title: "Consulting", text: "Accessibility audits for brands and products." },
  ],
};

export const SHOP_PICKS = [
  {
    title: "Editorial linen blazer",
    note: "My everyday confidence piece — drapes beautifully, breathes in coastal heat.",
    badge: "Amazon",
    image:
      "https://images.unsplash.com/photo-1591047139829-d91aecb6caea?auto=format&fit=crop&w=800&q=80",
    href: "#",
  },
  {
    title: "Sensory-friendly notebook",
    note: "Smooth paper, soft cover — gentle on AuDHD overwhelm days.",
    badge: "Amazon",
    image:
      "https://images.unsplash.com/photo-1531346878377-a5be20888e57?auto=format&fit=crop&w=800&q=80",
    href: "#",
  },
  {
    title: "Soft gold hoops",
    note: "Lightweight enough for EDS-friendly daily wear.",
    badge: "TikTok Shop",
    image:
      "https://images.unsplash.com/photo-1535632787350-4e68ef0ac584?auto=format&fit=crop&w=800&q=80",
    href: "#",
  },
  {
    title: "Posture-supportive chair cushion",
    note: "An EDS essential — gentle support without bulk.",
    badge: "Amazon",
    image:
      "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=800&q=80",
    href: "#",
  },
  {
    title: "Linen sheet set",
    note: "Sensory dream — soft, breathable, and ages beautifully.",
    badge: "Amazon",
    image:
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=800&q=80",
    href: "#",
  },
  {
    title: "Vintage leather tote",
    note: "From The Vintage Vault — selected favourite for daily use.",
    badge: "TikTok Shop",
    image:
      "https://images.unsplash.com/photo-1591561954557-26941169b49e?auto=format&fit=crop&w=800&q=80",
    href: "#",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Amanda has a rare gift — she sees the brand you're trying to build before you can articulate it yourself.",
    author: "Marketing Director",
    role: "Wellness brand",
  },
  {
    quote:
      "Her perspective on accessibility transformed how our entire leadership team thinks about product.",
    author: "CEO",
    role: "SaaS company",
  },
  {
    quote:
      "Working with Amanda is like having an editor for your career. Thoughtful, exacting, kind.",
    author: "Founder",
    role: "Coaching practice",
  },
];

export const SOCIAL = {
  instagram: "https://instagram.com/theamandaabbott",
  linkedin: "https://linkedin.com/in/theamandaabbott",
  facebook: "https://facebook.com/amandaabbottofficial",
  youtube: "https://youtube.com/@theamandaabbott",
  tiktok: "https://tiktok.com/@theamandaabbott",
  pinterest: "https://pinterest.com/theamandaabbott",
  coroflot: "https://coroflot.com/amandamccombs",
  email: "amanda@amandaabbott.com",
};

// Cal.com booking link
export const BOOKING = {
  calUsername: "amanda-abbott-diynum",
  calUrl: "https://cal.com/amanda-abbott-diynum",
};

// Brands & clients (public credits from her career)
export const BRANDS = [
  "Microsoft", "Xbox", "Microsoft Health",
  "LUXLA", "NastyGal", "Wasteland", "Sofia Boutique",
  "Solestruck", "KarmaLoop", "HauteLook", "Sur La Table",
  "Stone Cold Fox", "Intermix",
];

// Notable executive presentation clients (Microsoft years)
export const EXEC_CLIENTS = [
  "Phil Spencer", "Panos Panay", "Todd Holmdahl",
  "Mike Angiulo", "Stuart Ashmun", "Stephen Elop",
];

// Real editorial / modeling shots — drop-in gallery
export const EDITORIAL = [
  {
    src: "https://customer-assets.emergentagent.com/job_portfolio-hub-2548/artifacts/mzm6laff_AmandaAbbott21.jpg",
    alt: "Editorial — metallic suiting with statement jewelry",
    caption: "Editorial · Metallic Tailoring",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_portfolio-hub-2548/artifacts/73027m1q_AmandaAbbott88.jpg",
    alt: "Editorial — black and white intimate portrait",
    caption: "Editorial · Soft Light Portrait",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_portfolio-hub-2548/artifacts/w67uc06h_AmandaAbbott130.jpg",
    alt: "Editorial — yellow tee, denim, tattoos",
    caption: "Editorial · Coastal Energy",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_portfolio-hub-2548/artifacts/v7od6dk8_KB1_7985.jpg",
    alt: "Editorial — cream lace with red boots beside a cactus",
    caption: "Editorial · Lace & Light",
  },
];
